/** Text twin of the TikTok heatmap: hot windows and usage share per 5 s of the MV. */
import { fmtMs } from "../../lib/frames";
import type { FrameController } from "../player/controller";
import { heatTable, pctText } from "../timeline/project";
import type { Timeline } from "../types";

export function HeatTable({ tl, ctrl }: { tl: Timeline; ctrl: FrameController }) {
  const rows = heatTable(tl.heat, 5000);
  return (
    <section className="ws8-panel" aria-labelledby="ws8-heat-h">
      <h2 id="ws8-heat-h" className="ws8-h2">TikTok usage</h2>
      {tl.hot_windows.length === 0 && rows.length === 0 ? (
        <p data-testid="heat-empty">No TikTok usage on this timeline yet.</p>
      ) : (
        <>
          <table className="ws8-table" data-testid="hot-windows">
            <caption>Hot windows (MV clock)</caption>
            <thead><tr><th scope="col">From</th><th scope="col">To</th><th scope="col">Score</th><th scope="col">Seek</th></tr></thead>
            <tbody>
              {tl.hot_windows.map((w, i) => (
                <tr key={i}>
                  <td>{fmtMs(w.t0_mv_ms)}</td><td>{fmtMs(w.t1_mv_ms)}</td><td>{w.score.toFixed(2)}</td>
                  <td><button type="button" data-testid={`hot-seek-${i}`} onClick={() => ctrl.seekMs(w.t0_mv_ms)}
                    aria-label={`Seek to hot window ${fmtMs(w.t0_mv_ms)}`}>Seek</button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="ws8-scroll" tabIndex={0} role="region" aria-label="Usage per 5 seconds">
            <table className="ws8-table" data-testid="heat-table">
              <caption>Usage share per 5 s (play-weighted and by count)</caption>
              <thead><tr><th scope="col">Window</th><th scope="col">Play-weighted</th><th scope="col">By count</th></tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.t0}><td>{fmtMs(r.t0)}–{fmtMs(r.t1)}</td><td>{pctText(r.play)}</td><td>{pctText(r.count)}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </section>
  );
}
